







import {Component, Prop, Vue} from "vue-property-decorator";
import PersonDTO from "@/dto/person/PersonDTO";
import PersonSearch from "@/components/common/PersonSearch.vue";

@Component({
	components: {PersonSearch}
})
export default class PersonSearchModal extends Vue {

  @Prop({default: null})
  private title!: string | null;

  @Prop()
  private onPersonSelected!: (person: PersonDTO) => any

  selectAndClose(person: PersonDTO){
    this.$modal.hideAll();
    this.onPersonSelected(person);
  }

}
